import React, { useEffect, useState, Fragment } from 'react';


export default function ActivityIndicator ({color}) {

  const style = {
    borderColor: color || '#fff'
  }
    
    return (<div className="indicator" >
      <span className="blob" style={style}>&nbsp;</span>
      <span className="blob blob2" style={style}>&nbsp;</span>
    </div>)

}

